module.exports = __webpack_public_path__ + "img/metal_av@2x.ed67e544.png";